module.exports = __webpack_public_path__ + "img/palm-beach-county-main-detention-center-chiller-replacement-1.42b2567d.jpg";